import getConversationNodeId from 'owa-mail-reading-pane-store/lib/utils/getConversationNodeId';
import getTableViewFromTableQuery from '../actions/getTableViewFromTableQuery';
import loadTableViewFromTableQuery from '../actions/loadTableViewFromTableQuery';
import TableOperations from 'owa-mail-list-table-operations';
import updateInstrumentationContext from 'owa-mail-list-store/lib/utils/updateInstrumentationContext';
import { MailListItemSelectionSource } from 'owa-mail-store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
import { itemPartClicked } from 'owa-mail-actions/lib/mailListSelectionActions';
import { orchestrator } from 'satcheljs';
import { singleSelectRow } from 'owa-mail-actions';
import { loadMessageSuggestionIntoTable, removeSearchTableFromStore, } from 'owa-mail-search';
export default orchestrator(loadMessageSuggestionIntoTable, function (actionMessage) {
    var actionSource = actionMessage.actionSource;
    var row = actionMessage.row;
    var searchTableQuery = actionMessage.searchTableQuery;
    var referenceId = actionMessage.referenceId;
    var traceId = actionMessage.traceId;
    var itemPartId = actionMessage.itemPartId;
    var isOpenEmailSuggestionsInTabEnabled = is3SFeatureEnabled('sea-emailSuggestionsInTab');
    var tableView = getTableViewFromTableQuery(searchTableQuery);
    // add the single item into the table
    TableOperations.clear(tableView);
    TableOperations.addRow(0, row, tableView);
    if (!isOpenEmailSuggestionsInTabEnabled) {
        // do not load list view if the email suggestion is being
        // opened in a tab
        loadTableViewFromTableQuery(searchTableQuery, null /* loadTableViewDatapoint */, actionSource);
    }
    // instrumentation needs to be added before selecting the item
    // so the instrumentation context is available for logging ReadingPaneDisplayStart
    var instrumentationContext = {
        referenceKey: referenceId,
        index: 0,
        traceId: traceId,
    };
    updateInstrumentationContext(row.InstanceKey, tableView, instrumentationContext);
    // auto select the first and the only item
    singleSelectRow(tableView, tableView.rowKeys[0], false /* isUserNavigation */, MailListItemSelectionSource.SearchSuggestionClick);
    // itemPartId is only available for conversation view
    // call itemPartClicked to scroll to it
    if (!isOpenEmailSuggestionsInTabEnabled &&
        searchTableQuery.listViewType == 0 /* Conversation */ &&
        itemPartId) {
        var nodeId = getConversationNodeId(row.ConversationId.Id, itemPartId);
        var conversationItemParts = getMailStore().conversations.get(row.ConversationId.Id);
        var conversationNodeIds = conversationItemParts
            ? conversationItemParts.conversationNodeIds
            : [];
        itemPartClicked(nodeId, itemPartId, conversationNodeIds, tableView);
    }
    if (isOpenEmailSuggestionsInTabEnabled) {
        // remove the table view once item is loaded in tab
        // when list view is loaded (emailSuggestionsInTab feature off)
        // table is cleaned up in onAfterTableLoad
        removeSearchTableFromStore(tableView.id);
    }
});
//# sourceMappingURL=loadMessageSuggestionIntoTableOrchestrator.js.map